module.exports = __webpack_public_path__ + "static/media/modernHireInprogress.17188369.svg";